import { useId, useRef, useState } from "react";
import {
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonRadio,
  IonRadioGroup,
} from "@ionic/react";

import { translate } from "~utils";

import { ModalHeader } from "../ModalHeader";
import { SelectItem } from "../SelectItem";

/***** Types *****/
type Admin = {
  id: string;
  name: string;
};

type DayOfContactFieldProps = {
  onChange: (adminId: string) => void;
  admins: Admin[];
  defaultAdmin: Admin;
  isDisabled?: boolean;
  isRequired?: boolean;
};

/***** Component *****/
export function DayOfContactField(props: DayOfContactFieldProps) {
  const { onChange, admins, defaultAdmin, isDisabled = true, isRequired = false } = props;

  /*** Hooks ***/
  const modalId = useId();
  const modalRef = useRef<HTMLIonModalElement>(null);
  const [selectedAdminId, setSelectedAdminId] = useState<string>(defaultAdmin?.id || "");

  /*** Constants ***/
  const adminList = admins.length > 0 ? admins : [defaultAdmin];
  const selectedAdmin = adminList.find((admin) => admin.id === selectedAdminId) || defaultAdmin;

  /*** Handlers ***/
  const handleConfirm = () => {
    onChange(selectedAdminId);
    modalRef.current?.dismiss();
  };

  const handleCancel = () => {
    setSelectedAdminId(selectedAdmin?.id || "");
    modalRef.current?.dismiss();
  };

  /*** Render ***/
  return (
    <>
      <SelectItem
        id={modalId}
        label={translate("LABEL_DAY_OF_CONTACT")}
        value={selectedAdmin?.name}
        isDisabled={isDisabled}
        isRequired={isRequired}
        placeholder="Select admin"
      >
        <IonModal ref={modalRef} trigger={modalId}>
          <IonContent>
            <ModalHeader
              title={translate("LABEL_DAY_OF_CONTACT")}
              onModalDismiss={handleCancel}
              onModalConfirm={handleConfirm}
            />
            <IonRadioGroup
              value={selectedAdminId}
              onIonChange={(e) => setSelectedAdminId(e.detail.value)}
            >
              <IonList>
                {adminList.map((admin) => (
                  <IonItem key={admin.id}>
                    <IonLabel>{admin.name}</IonLabel>
                    <IonRadio slot="start" value={admin.id} />
                  </IonItem>
                ))}
              </IonList>
            </IonRadioGroup>
          </IonContent>
        </IonModal>
      </SelectItem>
    </>
  );
}
